import React from 'react'
import './Policy.css'

function TermsConditions() {
    return (
        <div className="legal-page">
            
            <div className="legal-hero">
                <h1>Terms and Conditions</h1>
            </div>

            <div className="breadcrumb">
                <a href="/">Home</a> &gt; Terms and Conditions
            </div>

            <div className="legal-content">
                <p className="last-updated">Last Updated: November 10, 2025</p>

                <section className="legal-section">
                    <h2>1. Introduction</h2>
                    <p>
                        Welcome to Sooru.AI. These Terms and Conditions govern your use of our website and services. 
                        By accessing or using our platform, you agree to be bound by these terms. If you do not agree 
                        with any part of these terms, please do not use our services.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>2. Definitions</h2>
                    <p>
                        <strong>"Platform"</strong> refers to the Sooru.AI website and all associated services.
                    </p>
                    <p>
                        <strong>"User"</strong> refers to any individual or entity accessing or using our platform.
                    </p>
                    <p>
                        <strong>"Services"</strong> refers to all features, tools, and functionalities provided by Sooru.AI.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>3. Use of Services</h2>
                    <p>
                        You agree to use our platform only for lawful purposes and in accordance with these Terms and Conditions. 
                        You must not use our services:
                    </p>
                    <ul>
                        <li>In any way that violates any applicable national or international law or regulation</li>
                        <li>To transmit, or procure the sending of, any advertising or promotional material without our prior written consent</li>
                        <li>To impersonate or attempt to impersonate Sooru.AI, our employees, other users, or any other person or entity</li>
                        <li>To engage in any conduct that restricts or inhibits anyone's use or enjoyment of the platform</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>4. User Accounts</h2>
                    <p>
                        When you create an account with us, you must provide accurate, complete, and current information. 
                        Failure to do so constitutes a breach of these Terms. You are responsible for safeguarding your 
                        account credentials and for any activities or actions under your account.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>5. Intellectual Property Rights</h2>
                    <p>
                        The platform and its original content, features, and functionality are owned by Sooru.AI and are 
                        protected by international copyright, trademark, patent, trade secret, and other intellectual 
                        property laws. You may not reproduce, distribute, modify, or create derivative works without our 
                        express written permission.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>6. User-Generated Content</h2>
                    <p>
                        You retain ownership of any content you submit to our platform. However, by submitting content, 
                        you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and 
                        display such content in connection with operating and promoting the platform.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>7. Prohibited Activities</h2>
                    <p>
                        You may not access or use the platform for any purpose other than that for which we make it available. 
                        Prohibited activities include, but are not limited to:
                    </p>
                    <ul>
                        <li>Attempting to bypass any security features</li>
                        <li>Using automated systems to access the platform</li>
                        <li>Interfering with or disrupting the platform or servers</li>
                        <li>Collecting or harvesting personal information from other users</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>8. Termination</h2>
                    <p>
                        We may terminate or suspend your account and access to the platform immediately, without prior notice 
                        or liability, for any reason, including if you breach these Terms and Conditions. Upon termination, 
                        your right to use the platform will immediately cease.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>9. Limitation of Liability</h2>
                    <p>
                        To the maximum extent permitted by law, Sooru.AI shall not be liable for any indirect, incidental, 
                        special, consequential, or punitive damages resulting from your use or inability to use the platform, 
                        even if we have been advised of the possibility of such damages.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>10. Disclaimer</h2>
                    <p>
                        The platform is provided on an "AS IS" and "AS AVAILABLE" basis without any warranties of any kind, 
                        either express or implied. We do not warrant that the platform will be uninterrupted, secure, or 
                        error-free.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>11. Governing Law</h2>
                    <p>
                        These Terms shall be governed by and construed in accordance with the laws of India, without regard 
                        to its conflict of law provisions. Any disputes arising from these Terms shall be subject to the 
                        exclusive jurisdiction of the courts in Bengaluru, Karnataka.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>12. Changes to Terms</h2>
                    <p>
                        We reserve the right to modify or replace these Terms at any time. We will provide notice of any 
                        material changes by posting the new Terms on this page with an updated "Last Updated" date. Your 
                        continued use of the platform after such modifications constitutes acceptance of the updated Terms.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>13. Contact Information</h2>
                    <p>
                        If you have any questions about these Terms and Conditions, please contact us at:
                    </p>
                    <p>
                        <strong>Email:</strong> <a href="mailto:info@sooru.ai">info@sooru.ai</a><br />
                        <strong>Phone:</strong> +91 97438 10910<br />
                        <strong>Address:</strong> No. 816, 27th Main Road, Sector - 1, H S R Layout, Bengaluru 560 102
                    </p>
                </section>
            </div>
        </div>
    )
}

export default TermsConditions